/**
 * Module definition and dependencies
 */
angular.module("Crm.Signature.Controller", ["Crm.LibPhoneNumberDirective", "transactionsService.Service", "contrats.Service", "signatures.Service", "recommandes.Service", "programmesService.Service", "documentsService.Service"])
/**
 * Controller
 */
.controller("genererContratModalCtrl", ["$uibModalInstance", "transaction", "regenererContrat", "infosDocument", "Contrat", "GenererContrat", "contact", "lot", "transactionDetails", "Contacts", "Documents", "NgTableParams", "Transactions", "Programme", "$rootScope", "$scope", "$filter", "$window", "$q", "ContactsCheck", "toaster", function ($uibModalInstance, transaction, regenererContrat, infosDocument, Contrat, GenererContrat, contact, lot, transactionDetails, Contacts, Documents, NgTableParams, Transactions, Programme, $rootScope, $scope, $filter, $window, $q, ContactsCheck, toaster) {
  var $ctrl = this;
  $ctrl.listDocuments = {};
  $ctrl.phoneRegex = /^([(]?[+]?[(]?[0-9]{1,3}[)]?)?[\s]?([0-9]{1,2}[\s.]?){5}$/;
  this.co_acquereur = {};
  this.active = "acquereurs";
  const navigationTab = [{
    name: "acquereurs",
    nexts: [{
      name: "financement",
      check: "financement"
    }, {
      name: "depot_garantie",
      check: "depot_garantie"
    }, {
      name: "pret"
    }],
    prev: null
  }, {
    name: "financement",
    nexts: [{
      name: "depot_garantie",
      check: "depot_garantie"
    }, {
      name: "pret"
    }],
    prev: [{
      name: "acquereurs"
    }]
  }, {
    name: "depot_garantie",
    nexts: [{
      name: "pret"
    }],
    prev: [{
      name: "financement",
      check: "financement"
    }]
  }, {
    name: "pret",
    nexts: [{
      name: "notaire",
      check: "notaire"
    }, {
      name: "annexes"
    }],
    prev: [{
      name: "depot_garantie",
      check: "depot_garantie"
    }]
  }, {
    name: "notaire",
    nexts: [{
      name: "annexes"
    }],
    prev: [{
      name: "pret"
    }]
  }, {
    name: "annexes",
    nexts: [{
      name: "lot"
    }],
    prev: [{
      name: "notaire",
      check: "notaire"
    }]
  }, {
    name: "lot",
    nexts: [{
      name: "fiscalite"
    }],
    prev: [{
      name: "annexes"
    }]
  }, {
    name: "fiscalite",
    nexts: [{
      name: "generer_contrat"
    }],
    prev: [{
      name: "lot"
    }]
  }, {
    name: "generer_contrat",
    nexts: null,
    prev: [{
      name: "fiscalite"
    }]
  }];
  /**
   * Ajout/supprime un document à la liste des documents selectionnés (this.documents)
   * @return void
   */

  this.selectionDocuments = item => {
    if (!item) {
      return;
    }

    const index = this.documents.findIndex(i => i.id === item.id);

    if (index == -1) {
      this.documents.push(item);
    } else {
      this.documents.splice(index, 1);
    }
  };
  /**
   * Permet de savoir si un document est sélectionné
   * @return boolean
   */


  this.isDocumentSelected = document => {
    if (!document) {
      return false;
    }

    return this.documents.some(a => a.id === document.id);
  };

  $ctrl.$onInit = () => {
    $ctrl.transaction = transaction;
    $ctrl.transactionDetails = transactionDetails;
    $ctrl.contact = contact;
    $ctrl.lot = lot;
    $ctrl.coacqId = "-1";
    $ctrl.documents = [];
    $ctrl.filtreDocuments = {
      lot_id: lot.id
    };
    $ctrl.configsContratReservation = $rootScope.configsContratReservation;
    let documentList = [];
    Documents.query({
      limit: -1,
      annexe_contrat: "true",
      programme_id: $ctrl.transaction.programme_id,
      lot_id: $ctrl.transaction.lot_id
    }).$promise.then(res => {
      documentList = res.data.filter(d => !d.lot_ids || d.lot_ids.indexOf($ctrl.transaction.lot_id) > -1);

      if (infosDocument.additional_data && infosDocument.additional_data.documents) {
        $ctrl.documents = infosDocument.additional_data.documents.map(url => {
          return documentList.find(d => d.url === url);
        }).filter(d => {
          return !!d;
        });
      } // On veut l'ensemble des documents selectionnés


      $ctrl.documents = angular.copy(documentList);
      $ctrl.listDocuments = new NgTableParams({}, {
        dataset: documentList
      });
    });

    if ($ctrl.transaction.programme_id) {
      Programme.get({
        programmeId: $ctrl.transaction.programme_id
      }).$promise.then(function (response) {
        $ctrl.programme = response;

        if ($ctrl.notaire && !$ctrl.notaire.date_livraison_previs) {
          $ctrl.notaire.date_livraison_previs = $ctrl.programme.date_livraison;
        }
      }, function (error) {
        console.log("promise error", error);
      });
    }
    /**
     * Récupération du coacquereur
     */


    if (infosDocument && infosDocument.additional_data && infosDocument.additional_data.co_acquereur && infosDocument.additional_data.co_acquereur.id) {
      Contacts.get({
        contactId: infosDocument.additional_data.co_acquereur.id
      }).$promise.then(contact => {
        this.isCoAcquereur = true; // Récup des additional_data avec mise à jour des infos du contact depuis BDD immodesk

        const cpAdditionalDataCoAcquereur = angular.copy(infosDocument.additional_data.co_acquereur);
        Object.assign(cpAdditionalDataCoAcquereur, this.formatContactForView(contact));
        Object.assign(this.co_acquereur, cpAdditionalDataCoAcquereur);
      }).catch(error => {
        console.log("error", error);
      });
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.acquereur) {
      $ctrl.contact.ville = infosDocument.additional_data.acquereur.ville;
      $ctrl.contact.adresse1 = infosDocument.additional_data.acquereur.adresse1;
      $ctrl.contact.adresse2 = infosDocument.additional_data.acquereur.adresse2;
      $ctrl.contact.adresse_pays = infosDocument.additional_data.acquereur.adresse_pays;
      $ctrl.contact.nom_jeune_fille = infosDocument.additional_data.acquereur.nom_jeune_fille;
      $ctrl.contact.prenom2 = infosDocument.additional_data.acquereur.prenom2;
      $ctrl.contact.prenom3 = infosDocument.additional_data.acquereur.prenom3;
      $ctrl.contact.ville_naissance = infosDocument.additional_data.acquereur.ville_naissance;
      $ctrl.contact.departement_naissance = infosDocument.additional_data.acquereur.departement_naissance;
      $ctrl.contact.pays_naissance = infosDocument.additional_data.acquereur.pays_naissance;
      $ctrl.contact.emploi_activite = infosDocument.additional_data.acquereur.emploi_activite;
      $ctrl.contact.situation_familiale = infosDocument.additional_data.acquereur.situation_familiale;

      if (infosDocument.additional_data.acquereur.date_naissance) {
        $ctrl.contact.date_naissance = infosDocument.additional_data.acquereur.date_naissance;
      }
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.date_mariage) {
      $ctrl.contact.date_mariage = infosDocument.additional_data.acquereur.date_mariage;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.regime) {
      $ctrl.contact.regime = infosDocument.additional_data.acquereur.regime;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.lieu_mariage) {
      $ctrl.contact.lieu_mariage = infosDocument.additional_data.acquereur.lieu_mariage;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.contrat_mariage) {
      $ctrl.contact.contrat_mariage = infosDocument.additional_data.acquereur.contrat_mariage;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.date_pacs) {
      $ctrl.contact.date_pacs = infosDocument.additional_data.acquereur.date_pacs;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.pacs_lieu) {
      $ctrl.contact.pacs_lieu = infosDocument.additional_data.acquereur.pacs_lieu;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.date_divorce) {
      $ctrl.contact.date_divorce = infosDocument.additional_data.acquereur.date_divorce;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.divorce_lieu) {
      $ctrl.contact.divorce_lieu = infosDocument.additional_data.acquereur.divorce_lieu;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.acquiert_pourcent) {
      $ctrl.contact.acquiert_pourcent = infosDocument.additional_data.acquereur.acquiert_pourcent;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur.notaire_mariage) {
      $ctrl.contact.notaire_mariage = infosDocument.additional_data.acquereur.notaire_mariage;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.acquereur_conjoint) {
      $ctrl.acquereur_conjoint = infosDocument.additional_data.acquereur_conjoint;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.co_acquereur_conjoint) {
      $ctrl.co_acquereur_conjoint = infosDocument.additional_data.co_acquereur_conjoint;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.co_acquereur_conjoint) {
      $ctrl.co_acquereur_conjoint = infosDocument.additional_data.co_acquereur_conjoint;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.notaire) {
      $ctrl.notaire = infosDocument.additional_data.notaire;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.depot) {
      $ctrl.depot = infosDocument.additional_data.depot;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.financement) {
      $ctrl.financement = infosDocument.additional_data.financement;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.fiscalite) {
      $ctrl.fiscalite = infosDocument.additional_data.fiscalite;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.amortissement) {
      $ctrl.amortissement = infosDocument.additional_data.amortissement;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.obtention) {
      $ctrl.obtention = infosDocument.additional_data.obtention;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.pack) {
      $ctrl.pack = infosDocument.additional_data.pack;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.option) {
      $ctrl.option = infosDocument.additional_data.option;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.conditions_particulieres) {
      $ctrl.conditions_particulieres = infosDocument.additional_data.conditions_particulieres;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.description_bien) {
      $ctrl.description_bien = infosDocument.additional_data.description_bien;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.pret) {
      $ctrl.pret = infosDocument.additional_data.pret;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.pret2) {
      $ctrl.pret2 = infosDocument.additional_data.pret2;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.pret3) {
      $ctrl.pret3 = infosDocument.additional_data.pret3;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.pret4) {
      $ctrl.pret4 = infosDocument.additional_data.pret4;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.signature) {
      $ctrl.signature = infosDocument.additional_data.signature;
    } //-------------------------------------------------------------------------------------------------------------------------


    if (infosDocument.additional_data && infosDocument.additional_data.societe && infosDocument.additional_data.isSociete) {
      $ctrl.societe = infosDocument.additional_data.societe;
    }

    if (infosDocument.additional_data && infosDocument.additional_data.isSociete) {
      $ctrl.isSociete = infosDocument.additional_data.isSociete;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.contact.date_naissance && $ctrl.contact.date_naissance.date) {
      $ctrl.contact.date_naissance = $ctrl.contact.date_naissance.date;
    } //-------------------------------------------------------------------------------------------------------------------------

  };

  this.nextTab = () => {
    const currentNavigationTab = navigationTab.find(n => n.name === this.active);

    if (!currentNavigationTab) {
      return;
    }

    const nextNavigation = this.findNavigation(currentNavigationTab.nexts, $rootScope.configsContratReservation);

    if (!nextNavigation) {
      return;
    }

    this.active = nextNavigation.name;
  };

  this.prevTab = () => {
    const currentNavigationTab = navigationTab.find(n => n.name === this.active);

    if (!currentNavigationTab) {
      return;
    }

    const prevNavigation = this.findNavigation(currentNavigationTab.prev, $rootScope.configsContratReservation);

    if (!prevNavigation) {
      return;
    }

    this.active = prevNavigation.name;
  };

  this.findNavigation = (targets, configsContratReservation) => {
    let newNavigation;

    if (!configsContratReservation) {
      return;
    }

    targets.forEach(n => {
      if (newNavigation) {
        return;
      }

      if (!n.check) {
        newNavigation = n;
      }

      if (configsContratReservation[n.check]) {
        newNavigation = n;
      }
    });
    return newNavigation;
  };

  $ctrl.datePickerOptions = {
    formatYear: "yy",
    startingDay: 1,
    timezone: "Europe/Paris"
  };

  $ctrl.format = (parent, key) => {// if (this[parent][key]) {
    //   const value = this[parent][key]
    //     .replace(/[\u202F\u00A0]/, "")
    //     .replaceAll(" ", "");
    //   const result = parseInt(value).toLocaleString("fr-FR");
    //   this[parent][key] = result.toString();
    // }
  };

  $ctrl.regenererContrat = regenererContrat;
  $ctrl.selectedoptionsGenererContrat = infosDocument && infosDocument.additional_data ? infosDocument.additional_data.recoursPret : true;
  $ctrl.optionsGenererContrat = [{
    name: "Absence de recours à un prêt par l'acquéreur",
    value: false
  }, {
    name: "Recours à un prêt par l'acquéreur",
    value: true
  }];

  $ctrl.setSameAddress = function () {
    console.log("setSameAddress");
    var fields = ["adresse1", "adresse2", "cp", "ville"];
    var source = $ctrl.co_acquereur.sameAdress ? $ctrl.contact : {};
    let field;

    for (var i = 0; i < fields.length; i++) {
      field = fields[i];
      $ctrl.co_acquereur[field] = source[field] || "";
    }
  };

  $ctrl.moveUp = function (index) {
    console.log('$ctrl.moveUp');

    if (index > 0) {
      var item = $ctrl.listDocuments.data.splice(index, 1)[0];
      $ctrl.listDocuments.data.splice(index - 1, 0, item);
    }
  };

  $ctrl.moveDown = function (index) {
    console.log('$ctrl.moveDown');

    if (index < $ctrl.listDocuments.data.length - 1) {
      var item = $ctrl.listDocuments.data.splice(index, 1)[0];
      $ctrl.listDocuments.data.splice(index + 1, 0, item);
    }
  };
  /**
   * Submit du formulaire signature
   */


  $ctrl.valider = () => {
    this.isSubmit = true;

    if (this.formValidAcquereur && this.formValidAcquereur.$invalid || this.formValidCoAcquereur && this.formValidCoAcquereur.$invalid && this.isCoAcquereur || this.optionsGenererContrat && this.formObjPret1 && this.formObjPret1.$invalid || this.isPret2 && this.formObjPret2 && this.formObjPret2.$invalid) {
      return;
    } // check coacquereur


    if (this.co_acquereur && !angular.equals(this.co_acquereur, {}) && !this.co_acquereur.id) {
      return this.ContactCheck(this.co_acquereur).then(response => {
        if (response.success) {
          return this.createOrUpdateAcquereurs();
        }
      });
    } else {
      return this.createOrUpdateAcquereurs();
    }
  };
  /**
   * Check si un contact existe déjà
   */


  this.ContactCheck = contact => {
    if (!contact) {
      return;
    }

    return ContactsCheck.query(contact).$promise.then(response => {
      const homonyme = ["Nom", "Prenom"];

      if (response.type && response.type === "contact_denonce") {
        const bodyMessageContactDenonce = response.contact ? `Création impossible. Ce contact est déjà dénoncé par ${response.contact.commercialisateur_nom} jusqu'au ${moment(response.contact.date_fin.date).format("DD/MM/YYYY")}` : response.message;
        toaster.pop({
          type: "error",
          body: bodyMessageContactDenonce
        });
        return {
          success: false
        };
      } // Forcer la creation contact pour les homonyme
      else if (response.message && JSON.stringify(response.message) == JSON.stringify(homonyme)) {
          toaster.pop({
            type: "Infos",
            title: "Infos",
            body: "Attention un contact exsite déjà avec les mêmes Nom et Prénom"
          });
          return {
            success: true
          };
        } else if (response.contact) {
          const list = response.message.join(", ");
          toaster.pop({
            type: "Infos",
            title: "Infos",
            body: `Le contact existe avec le(s) même(s) : ${list}`
          });
          return {
            success: false
          };
        }

      return {
        success: true
      };
    }).catch(error => {
      console.log("error", error);
      toaster.pop({
        type: "error",
        title: "Attention",
        body: error.message
      });
    });
  };
  /**
   * Mise à jour de l'acquéreur
   * et création/mise à jour du coacquereur si présent
   */


  this.createOrUpdateAcquereurs = () => {
    const promises = []; //Update de l'acquéreur

    const acquereur = this.formatContactForAPI(new Contacts(this.contact));
    const promiseAcquereur = acquereur.createOrUpdate();
    promises.push(promiseAcquereur); //Create or Update du co-acquéreur

    if (this.isCoAcquereur) {
      const coAcquereur = this.formatContactForAPI(new Contacts(this.co_acquereur)); // Avancement commercial "RESA/COMPROMIS"

      coAcquereur.avancement_id = 17; // Attribution vendeur le même que l'acquereur

      coAcquereur.vendeur_id = acquereur.vendeur_id ? acquereur.vendeur_id : null; // Converti un contact en client ne peut pas etre set en coacquereur sinon

      coAcquereur.discr_to_client = true;
      const promiseCoAcquereur = coAcquereur.createOrUpdate();
      promises.push(promiseCoAcquereur);
    }

    return $q.all(promises).then(([repAcquereur, repCoAcquereur]) => {
      repAcquereur = this.formatContactForView(repAcquereur);
      Object.assign(this.contact, repAcquereur);

      if (repCoAcquereur) {
        repCoAcquereur = this.formatContactForView(repCoAcquereur);
        Object.assign(this.co_acquereur, repCoAcquereur);
      }

      this.processGenererContrat();
    }).catch(error => {
      console.log("error", error);
    });
  };
  /**
   * format un contact pour l'envoyer à l'API
   */


  this.formatContactForAPI = contact => {
    if (contact.date_naissance) {
      contact.date_naissance = moment(contact.date_naissance).format("YYYY-MM-DD 12:00:00");
    }

    if (contact.date_mariage) {
      contact.date_mariage = moment(contact.date_mariage).format("YYYY-MM-DD 12:00:00");
    }

    if (contact.contrat_mariage) {
      contact.date_mariage = moment(contact.date_mariage).format("YYYY-MM-DD 12:00:00");
    }

    return contact;
  };
  /**
   * format un contact pour la view
   */


  this.formatContactForView = contact => {
    if (contact.date_naissance && contact.date_naissance.date) {
      contact.date_naissance = contact.date_naissance.date;
    }

    return contact;
  };
  /**
   * Supprime l'ancien contrat et génère un nouveau
   */


  this.processGenererContrat = () => {
    if ($ctrl.regenererContrat) {
      var contrat = new Contrat({
        documentId: infosDocument.id
      });
      return contrat.$delete().then(function (response) {
        $rootScope.$broadcast("contratSupprime");
        return $ctrl.genererContrat();
      }).catch(function (error) {
        $rootScope.$broadcast("toasterError", error.message);
      });
    } else {
      return $ctrl.genererContrat().then(response => {
        $uibModalInstance.close();
        $rootScope.$broadcast("modalContratClose");
      }).catch(error => {
        $rootScope.$broadcast("toasterError", error.message);
      });
    }
  };
  /**
   *
   */


  $scope.$watch(() => this.selectCoAcquereur, (newValue, oldValue) => {
    if (!newValue) {
      return;
    }

    this.co_acquereur = this.formatContactForView(newValue);
  }, true);

  $ctrl.annuler = function () {
    $uibModalInstance.dismiss("cancel");
  }; //-------------------------------------------------------------------------------------------------------------------------
  //
  //-------------------------------------------------------------------------------------------------------------------------
  // Delete les lots liees non selectionner


  $ctrl.deleteLotAnnexe = function () {
    let lot_id_principal = $ctrl.transactionDetails.lot_id;
    let lot_id_all = $ctrl.transactionDetails.lots_id;
    var index = lot_id_all.indexOf(lot_id_principal);
    if (index !== -1) lot_id_all.splice(index, 1);
    return lot_id_all;
  }; // Filtre lot annexe


  $ctrl.lots_annexeFilter = function (annexe) {
    let lotAnnexeSelected = $ctrl.deleteLotAnnexe();

    if (Object.values(lotAnnexeSelected).indexOf(annexe.id) > -1) {
      return annexe;
    }
  }; // Addition des lots et des lots annexes


  $ctrl.additionnalLots = function () {
    var totalPrice = 0;
    let lotAnnexeSelected = $ctrl.deleteLotAnnexe();

    for (var i = 0; i < $ctrl.lot.lots_annexes.length; i++) {
      // Check : lot annexe existe coché
      let x = $ctrl.lot.lots_annexes[i].id;

      if (Object.values(lotAnnexeSelected).indexOf(x) > -1) {
        let totalAnnexes = $ctrl.lot.lots_annexes[i].prix_vente_total;
        totalPrice += totalAnnexes;
      }
    }

    totalPrice += Number($ctrl.transactionDetails.prix_ttc);
    return totalPrice;
  };

  $ctrl.genererContrat = () => {
    var paramsContrat = {
      transactionId: transaction.id
    };
    var additional_data = {}; //-------------------------------------------------------------------------------------------------------------------------

    if ($ctrl.contact) {
      let tmpContact = angular.copy($ctrl.contact);

      if (tmpContact.date_naissance && tmpContact.date_naissance.date) {
        tmpContact.date_naissance = moment(tmpContact.date_naissance.date).format("YYYY-MM-DD");
      }

      if (tmpContact.date_mariage && tmpContact.date_mariage.date) {
        tmpContact.date_mariage = moment(tmpContact.date_mariage.date).format("YYYY-MM-DD");
      }

      if (tmpContact.contrat_mariage && tmpContact.contrat_mariage.date) {
        tmpContact.contrat_mariage = moment(tmpContact.contrat_mariage.date).format("YYYY-MM-DD");
      }

      if (tmpContact.date_pacs && tmpContact.date_pacs.date) {
        tmpContact.date_pacs = moment(tmpContact.date_pacs.date).format("YYYY-MM-DD");
      }

      if (tmpContact.date_divorce && tmpContact.date_divorce.date) {
        tmpContact.date_divorce = moment(tmpContact.date_divorce.date).format("YYYY-MM-DD");
      }

      additional_data.acquereur = tmpContact;
    }

    if ($ctrl.optionsGenererContrat) {
      additional_data.recoursPret = $ctrl.selectedoptionsGenererContrat;
    }

    additional_data.isSociete = $ctrl.isSociete;

    if ($ctrl.acquereur_conjoint) {
      additional_data.acquereur_conjoint = $ctrl.acquereur_conjoint;
    }

    if ($ctrl.notaire) {
      let tmpNotaire = angular.copy($ctrl.notaire);

      if (tmpNotaire.date_reception_acte && tmpNotaire.date_reception_acte.date) {
        tmpNotaire.date_reception_acte = moment(tmpNotaire.date_reception_acte.date).format("YYYY-MM-DD");
      }

      additional_data.notaire = tmpNotaire;
    }

    if ($ctrl.co_acquereur && Object.keys($ctrl.co_acquereur).length) {
      let tmpCoAcquereur = angular.copy($ctrl.co_acquereur);

      if (tmpCoAcquereur.date_naissance && tmpCoAcquereur.date_naissance.date) {
        tmpCoAcquereur.date_naissance = moment(tmpCoAcquereur.date_naissance.date).format("YYYY-MM-DD");
      }

      additional_data.co_acquereur = tmpCoAcquereur;
    }

    if ($ctrl.co_acquereur_conjoint) {
      additional_data.co_acquereur_conjoint = $ctrl.co_acquereur_conjoint;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.selectedoptionsGenererContrat) {
      if ($ctrl.pret) {
        additional_data.pret = angular.copy($ctrl.pret);

        if (additional_data.pret.date_limite_obtention) {
          additional_data.pret.date_limite_obtention = moment(additional_data.pret.date_limite_obtention).format("YYYY-MM-DD");
        }
      }

      if ($ctrl.pret2) {
        additional_data.pret2 = angular.copy($ctrl.pret2);

        if (additional_data.pret2.date_limite_obtention) {
          additional_data.pret2.date_limite_obtention = moment(additional_data.pret2.date_limite_obtention).format("YYYY-MM-DD");
        }
      }

      if ($ctrl.pret3) {
        additional_data.pret3 = angular.copy($ctrl.pret3);

        if (additional_data.pret3.date_limite_obtention) {
          additional_data.pret3.date_limite_obtention = moment(additional_data.pret3.date_limite_obtention).format("YYYY-MM-DD");
        }
      }

      if ($ctrl.pret4) {
        additional_data.pret4 = angular.copy($ctrl.pret4);

        if (additional_data.pret4.date_limite_obtention) {
          additional_data.pret4.date_limite_obtention = moment(additional_data.pret4.date_limite_obtention).format("YYYY-MM-DD");
        }
      }
    } else {
      delete additional_data.pret;
      delete additional_data.pret2;
      delete additional_data.pret3;
      delete additional_data.pret4;
    }

    additional_data.documents = $ctrl.listDocuments.data.filter(function (d) {
      return $ctrl.isDocumentSelected(d);
    }).map(function (d) {
      return d.url;
    }); //-------------------------------------------------------------------------------------------------------------------------

    if ($ctrl.depot) {
      additional_data.depot = $ctrl.depot;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.financement) {
      additional_data.financement = $ctrl.financement;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.amortissement) {
      additional_data.amortissement = $ctrl.amortissement;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.obtention) {
      additional_data.obtention = $ctrl.obtention;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.pack) {
      additional_data.pack = $ctrl.pack;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.option) {
      additional_data.option = $ctrl.option;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.conditions_particulieres) {
      additional_data.conditions_particulieres = $ctrl.conditions_particulieres;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.description_bien) {
      additional_data.description_bien = $ctrl.description_bien;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.signature) {
      additional_data.signature = $ctrl.signature;
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.fiscalite) {
      additional_data.fiscalite = angular.copy($ctrl.fiscalite);
    } //-------------------------------------------------------------------------------------------------------------------------


    if ($ctrl.societe) {
      additional_data.societe = angular.copy($ctrl.societe);
    } // paramsContrat.additional_data = JSON.stringify(additional_data);


    paramsContrat.additional_data = additional_data;
    var genererContrat = new GenererContrat(paramsContrat);
    return genererContrat.$save().then(function (response) {
      transaction.contrat_reservation_id = response.id;
      return Transactions.get({
        id: transaction.id
      }).$promise.then(function (response) {
        transaction = response;
        $uibModalInstance.close();

        if ($ctrl.regenererContrat) {
          $rootScope.$broadcast("contratRegenerer", response);
        } else {
          $rootScope.$broadcast("contratGenerer", response);
        }

        $window.location.reload();
      }).catch(function (error) {});
    }).catch(function (error) {
      const message = error.data.message ? error.data.message : error.message;
      $rootScope.$broadcast("toasterError", message);
    });
  };

  this.resetCoAcquereur = () => {
    this.co_acquereur = {};
    this.selectCoAcquereur = {};
  };

  this.handleChangeIntentionAchat = value => {
    if (!$ctrl.fiscalite) {
      $ctrl.fiscalite = {};
    }

    this.resetIntentionAchat();
    this.switchIntentionAchat(value);
  };

  this.resetIntentionAchat = () => {
    $ctrl.fiscalite.acquisition_residence_principale = false;
    $ctrl.fiscalite.investissement_residence_secondaire = false;
    $ctrl.fiscalite.impot = false;
    $ctrl.fiscalite.acquisition_investissement_hors_pinel = false;
    $ctrl.fiscalite.investissement_locatif_meuble = false;
  };

  this.switchIntentionAchat = value => {
    switch (value) {
      case "acquisition_residence_principale":
        $ctrl.fiscalite.acquisition_residence_principale = true;
        break;

      case "investissement_residence_secondaire":
        $ctrl.fiscalite.investissement_residence_secondaire = true;
        break;

      case "impot":
        $ctrl.fiscalite.impot = true;
        break;

      case "acquisition_investissement_hors_pinel":
        $ctrl.fiscalite.acquisition_investissement_hors_pinel = true;
        break;

      case "investissement_locatif_meuble":
        $ctrl.fiscalite.investissement_locatif_meuble = true;
        break;

      default:
        break;
    }
  };

  $scope.$watch(() => this.isSociete, (newValue, oldValue) => {
    if (newValue === undefined) {
      return;
    }

    if (newValue) {
      this.isCoAcquereur = false;
    }

    this.resetCoAcquereur();
  }, true);
  $scope.$watch(() => this.isCoAcquereur, (newValue, oldValue) => {
    if (newValue === undefined || oldValue === undefined) {
      return;
    }

    this.resetCoAcquereur();
  }, true);
}]).controller("startLREModalCtrl", ["$uibModalInstance", "transaction", "Recommandes", function ($uibModalInstance, transaction, Recommandes) {
  var $ctrl = this;
  $ctrl.transaction = transaction;

  $ctrl.valider = function () {
    var recommande = new Recommandes({
      transaction_document_id: $ctrl.transaction.contrat_reservation_id
    });
    return recommande.$save().then(function (response) {
      $uibModalInstance.close();
      $rootScope.$broadcast("recommandeEnvoye");

      if (response.status) {
        transaction.recommande_status = response.status;
      }

      if (response.created_date) {
        transaction.recommande_created_date = {};
        transaction.recommande_created_date.date = response.created_date;
      }

      if (response.additional_data) {
        transaction.recommande_additional_data_parse = response.additional_data;
      }

      if (response.demand_id) {
        transaction.recommande_demande_id = response.demand_id;
      }
    }, function (error) {
      $rootScope.$broadcast("toasterError", error.message);
    });
  };

  $ctrl.annuler = function () {
    $uibModalInstance.dismiss("cancel");
  };
}]).controller("signatureContact", ["$scope", function ($scope) {
  this.initForm = () => {
    this.formObj = $scope[this.formName];
  };

  $scope.$watch(() => this.countrySelected, country => {
    if (!country || !country.id) {
      return;
    }

    this.contact.pays = country.id;
  });
}]).controller("signaturePret", ["$scope", function ($scope) {
  this.initForm = () => {
    if (this.formDisabled === undefined) {
      this.formDisabled = false;
    }

    this.formObj = $scope[this.formName];

    if (this.pret && this.pret.date_limite_obtention) {
      const momentDate = moment(this.pret.date_limite_obtention);
      this.pret.date_limite_obtention = new Date(momentDate.year(), momentDate.month(), momentDate.date());
    }
  };

  this.format = (parent, key) => {// if (this[parent][key]) {
    //   const value = this[parent][key]
    //     .replace(/[\u202F\u00A0]/, "")
    //     .replaceAll(" ", "");
    //   const result = parseInt(value).toLocaleString("fr-FR");
    //   this[parent][key] = result.toString();
    // }
  };
}]).controller("modalRestartAR24Ctrl", ["$uibModalInstance", "$rootScope", "transaction", "ReStartArr", "toaster", function ($uibModalInstance, $rootScope, transaction, ReStartArr, toaster) {
  this.transaction = transaction;

  this.valider = () => {
    ReStartArr.delete({
      transactionId: transaction.id,
      documentId: transaction.contrat_reservation_id
    }).$promise.then(response => {
      $uibModalInstance.close();
      toaster.pop({
        type: "success",
        title: "",
        body: "Ancien(s) AR supprimé(s)"
      });
      $rootScope.$broadcast("envoieAR");
    }).catch(error => {
      $uibModalInstance.close();

      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
  };

  this.annuler = () => {
    $uibModalInstance.close();
  };
}]).controller("genererContrat", ["ConfigsCommercialisateurs", "$rootScope", "$uibModal", "DocumentsProcedure", "$scope", "VerifTemplates", "SendArr", "Contrat", "DeleteContratSigned", "toaster", function (ConfigsCommercialisateurs, $rootScope, $uibModal, DocumentsProcedure, $scope, VerifTemplates, SendArr, Contrat, DeleteContratSigned, toaster) {
  this.$onInit = () => {
    this.message = "";
    this.signers = [];
    this.contratFiles = []; // Contient le contract non signé au format docx/pdf

    this.contratFilesAcquereur = []; // Contient l'AR (proof, proof_reception) de l'acquereur

    this.contratFilesCoAcquereur = []; // Contient l'AR (proof, proof_reception) du co-acquereur

    this.submitClicked = false;
    this.procedure;
    this.btnSendAr = false;
    ConfigsCommercialisateurs.getConfigCommercialisateurs().then(response => {
      this.configCommercialisateur = response.data;
    }).catch(error => {
      console.log(error);

      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
    this.verifTemplates();

    if (this.transaction && this.transaction.contrat_reservation_id > 0) {
      this.getProcedure();
    }
  };
  /**
   * Récupération du contrat au format docx / pdf
   */


  this.getContrat = () => {
    this.contratFiles.length = 0; // reset array

    Contrat.get({
      documentId: this.transaction.contrat_reservation_id
    }).$promise.then(response => {
      const nbArSended = parseInt(response.ar_count_request);

      if (nbArSended == 1) {
        this.btnSendAr = true;
      }

      if (this.transaction.signature_procedure_status != 2) {
        if ($rootScope.membreConnecter && $rootScope.membreConnecter.is_partenaire === false) {
          this.contratFiles.push({
            url: response.document_docx,
            title: "Contrat au format docx",
            disabled: this.transaction.processus_generating !== 50,
            iconClass: "icon-docx"
          });
        }

        this.contratFiles.push({
          url: response.document_url,
          title: "Contrat non signé",
          disabled: this.transaction.processus_generating !== 50,
          iconClass: "icon-pdf"
        });
      }

      if (this.transaction.contract_signed_document_url && (this.transaction.signature_procedure_status > 30 || this.transaction.signature_procedure_status == 2)) {
        this.contratFiles.push({
          url: this.transaction.contract_signed_document_url,
          title: "Contrat signé",
          disabled: false,
          iconClass: "icon-pdf"
        });
      }
    });
  };

  this.envoieAR = (transaction = null) => {
    transaction = transaction ? transaction : this.transaction;
    this.submitClicked = true;
    SendArr.get({
      transactionId: transaction.id,
      documentId: transaction.contrat_reservation_id
    }).$promise.then(response => {
      if (response && response.signature_procedure_status) {
        transaction.signature_procedure_status = response.signature_procedure_status;
        this.message = "AR envoyé";
        toaster.pop({
          type: "success",
          title: "",
          body: "AR24 envoyé(s) au(x) destinataire(s)"
        });
      }

      this.btnSendAr = false;
      transaction.procedure = response;
    }).catch(error => {
      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
  };

  $scope.$on("envoieAR", (event, data) => {
    this.envoieAR();
  });

  this.restartAR = () => {
    $uibModal.open({
      templateUrl: "src/signature/modal-restartAR.html",
      controller: "modalRestartAR24Ctrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: () => {
          return this.transaction;
        }
      }
    });
  };

  this.verifTemplates = () => {
    if (!this.transaction || !this.transaction.programme_id) {
      return;
    }

    VerifTemplates.get({
      programmeId: this.transaction.programme_id
    }).$promise.then(response => {
      this.transaction.isTemplateAvailable = response.template;
    });
  };

  this.getProcedure = () => {
    this.disabledRefreshTransactionProcedure = true;
    DocumentsProcedure.get({
      transactionId: this.transaction.id,
      documentId: this.transaction.contrat_reservation_id
    }).$promise.then(response => {
      this.disabledRefreshTransactionProcedure = false;
      this.procedure = response;
      this.validators = [];

      if (response && response.signature_procedure_status) {// remove - pourquoi modifier les données ???
        // this.transaction.signature_procedure_status =
        //   response.signature_procedure_status;
      }

      const membreProcedureId = "immodesk-membre-" + $rootScope.membreConnecter.id;
      this.myReservant = this.procedure.reservant && this.procedure.reservant.reference === membreProcedureId ? this.procedure.reservant : null;

      if (response.validators) {
        this.validators = response.validators;
        this.validators.forEach(v => {
          v.position -= response.signers.length;
        });
        this.validators.sort(compare); // TODO a delete après update de l'API membre

        this.myValidator = this.validators.find(v => v.reference === membreProcedureId);
      }

      if (this.procedure) {
        this.contratFilesAcquereur.length = 0; // reset array

        this.contratFilesCoAcquereur.length = 0; // reset array
        // get documents SRU

        this.getDocsSru(this.contratFilesAcquereur, 0);
        this.getDocsSru(this.contratFilesCoAcquereur, 1); // get preuve de dépôt, AR

        if (this.procedure.ars) {
          this.getProof(this.contratFilesAcquereur, 0);
          this.getProof(this.contratFilesCoAcquereur, 1);
        }
      }

      this.getContrat();
    }).catch(error => {
      this.disabledRefreshTransactionProcedure = false;
      console.log(error);

      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
  };
  /**
   * Check si il existe une preuve de dépot (proofReception) à l'index (index) si oui on l'ajoute à arrayDest
   * Check si il existe un AR24 (proof) à l'index (index) si oui on l'ajoute à arrayDest
   * @param arrayDest array (contratFilesAcquereur, contratFilesCoAcquereur)
   * @param index integer (0 = acquereur, 1 = co-acquereur)
   */


  this.getProof = (arrayDest, index) => {
    if (!this.procedure || !this.procedure.ars || !this.procedure.ars[index] || !arrayDest) {
      return;
    }

    const proofReception = this.procedure.ars[index].proof_reception;
    const proof = this.procedure.ars[index].proof;
    const proofRefused = this.procedure.ars[index].proof_refused;
    const proofNegligence = this.procedure.ars[index].proof_negligence;

    if (proofReception) {
      arrayDest.push({
        url: proofReception,
        title: "Preuve de dépôt et d'envoi",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }

    if (proof) {
      arrayDest.push({
        url: proof,
        title: "Preuve de réception (AR24)",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }

    if (proofRefused) {
      arrayDest.push({
        url: proofRefused,
        title: "Preuve de refus",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }

    if (proofNegligence) {
      arrayDest.push({
        url: proofNegligence,
        title: "Preuve de négligence",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }
  };

  this.getDocsSru = (arrayDest, index) => {
    if (!this.procedure) {
      return;
    }

    const documentSruAcquereurUrl = this.procedure.document_sru_acquereur_url;
    const documentSruCoAcquereurUrl = this.procedure.document_sru_co_acquereur_url;

    if (index === 0 && documentSruAcquereurUrl) {
      arrayDest.push({
        url: documentSruAcquereurUrl,
        title: "Courrier SRU",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }

    if (index === 1 && documentSruCoAcquereurUrl) {
      arrayDest.push({
        url: documentSruCoAcquereurUrl,
        title: "Courrier SRU",
        disabled: false,
        iconClass: "icon-pdf"
      });
    }
  };

  function compare(a, b) {
    if (a.position < b.position) {
      return -1;
    }

    if (a.position > b.position) {
      return 1;
    }

    return 0;
  }

  this.refreshTransactionProcedure = () => {
    $rootScope.$broadcast("refreshTransactionProcedure");
    this.getProcedure();
  }; // Ajoutez la nouvelle fonction ici


  this.openImportContratModal = function () {
    $uibModal.open({
      templateUrl: "src/signature/modal-import-contrat.html",
      controller: "modalImportContratCtrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: () => {
          return this.transaction;
        }
      }
    }).result.then(response => {
      // Mise à jour de la transaction après l'importation
      if (response && response.contrat_reservation_id) {
        this.transaction.contrat_reservation_id = response.contrat_reservation_id;
        this.transaction.signature_procedure_status = 2; // Statut pour "Contrat importé"
      }
    });
  };

  this.confirmDeleteSignedContract = function () {
    // Afficher une confirmation avant la suppression
    $uibModal.open({
      templateUrl: "src/signature/modal-delete-contrat.html",
      controller: "modalDeleteContratCtrl",
      controllerAs: "$ctrl",
      size: "md"
    }).result.then(function (result) {
      if (result) {
        // L'utilisateur a confirmé la suppression
        this.deleteSignedContract();
      }
    }.bind(this));
  };

  this.deleteSignedContract = function () {
    this.deleteContratLoading = true;
    this.deleteContratClicked = true; // Appel à l'API spécifique pour supprimer le contrat signé

    DeleteContratSigned.delete({
      id: this.transaction.contrat_reservation_id
    }).$promise.then(function (response) {
      // Mise à jour de l'interface après suppression
      this.transaction.contract_signed_document_url = null;
      this.transaction.signature_procedure_status = 0; // Réinitialiser le statut

      this.transaction.contrat_reservation_id = 0; // signatureRequirements

      if (this.signatureRequirements) {
        this.signatureRequirements.messages = [];
        this.signatureRequirements.valid = true;
      } // Supprimer le contrat signé de la liste des fichiers


      this.contratFiles = this.contratFiles.filter(function (file) {
        return file.title !== "Contrat signé";
      });
      toaster.pop({
        type: "success",
        title: "Succès",
        body: "Le contrat signé a été supprimé avec succès."
      });
    }.bind(this)).catch(function (error) {
      toaster.pop({
        type: "error",
        title: "Erreur",
        body: error.data && error.data.message ? error.data.message : "Une erreur est survenue lors de la suppression du contrat."
      });
    }).finally(function () {
      this.deleteContratLoading = false;
      this.deleteContratClicked = false;
    }.bind(this));
  };

  $scope.$on("signatureDemandeEffectuee", (event, data) => {
    this.getProcedure();
  });
  $scope.$on("modalContratClose", (event, data) => {
    this.getProcedure();
  });
  $scope.$on("notification_contrat_generer", (event, data) => {
    this.getProcedure();
  });
  $scope.$on("contratRegenerer", (event, newTransaction) => {
    if (!newTransaction || !newTransaction.contrat_reservation_id) {
      console.log("error newTransaction / newTransaction.contrat_reservation_id is empty");
      return;
    }

    this.transaction.contrat_reservation_id = newTransaction.contrat_reservation_id;
    this.transaction.signature_procedure_status = 0;
    this.getProcedure();
  });
  $scope.$on("signatureAbandonnee", (event, transaction) => {
    console.log("signatureAbandonnee transaction : ", transaction); // this.transaction.contrat_reservation_id =
    //   transaction.contrat_reservation_id; // Reset contrat reservation id
    // this.transaction.signature_procedure_status =
    //   transaction.signature_procedure_status; // Annuler - Refuser
  });
  $scope.$on("contratImporte", function (event, data) {
    // Mettre à jour l'URL du contrat signé
    if (data && data.contract_signed_document_url) {
      this.transaction.contract_signed_document_url = data.contract_signed_document_url;
      this.transaction.contrat_reservation_id = data.id; // Vérifier si le lien existe déjà dans contratFiles

      var contratSigneExiste = false;

      for (var i = 0; i < this.contratFiles.length; i++) {
        if (this.contratFiles[i].title === "Contrat signé") {
          // Mettre à jour l'URL
          this.contratFiles[i].url = data.contract_signed_document_url;
          this.contratFiles[i].disabled = false;
          contratSigneExiste = true;
          break;
        }
      } // Si le lien n'existe pas, l'ajouter


      if (!contratSigneExiste) {
        this.contratFiles.push({
          url: data.contract_signed_document_url,
          title: "Contrat signé",
          disabled: false,
          iconClass: "icon-pdf"
        });
      } // Mettre à jour le statut de la signature


      this.transaction.signature_procedure_status = 2; // Statut "Contrat importé"
      // Ajouter le message dans signatureRequirements

      if (!this.signatureRequirements) {
        this.signatureRequirements = {
          valid: false,
          messages: ["Contrat signé importé manuellement"]
        };
      } else {
        this.signatureRequirements.valid = false;
        this.signatureRequirements.messages = ["Contrat signé importé manuellement"];
      }
    }
  }.bind(this));
}]).controller("modalImportContratCtrl", ["$uibModalInstance", "$rootScope", "transaction", "ImportContrat", function ($uibModalInstance, $rootScope, transaction, ImportContrat) {
  var $ctrl = this;
  $ctrl.transaction = transaction;
  $ctrl.contratFile = null;

  $ctrl.importerContrat = function () {
    if (!$ctrl.contratFile) {
      return;
    }

    var formData = new FormData();
    formData.append("file", $ctrl.contratFile);
    formData.append("transaction_id", $ctrl.transaction.id);
    return ImportContrat.upload(formData).$promise.then(function (response) {
      $uibModalInstance.close(response);
      $rootScope.$broadcast("contratImporte", response);
    }).catch(function (error) {
      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }

      $uibModalInstance.dismiss("error");
    });
  };

  $ctrl.annuler = function () {
    $uibModalInstance.dismiss("cancel");
  };
}]).controller("modalDeleteContratCtrl", ["$uibModalInstance", function ($uibModalInstance) {
  this.confirmer = function () {
    $uibModalInstance.close(true); // Renvoie true si confirmé
  };

  this.annuler = function () {
    $uibModalInstance.dismiss("cancel");
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module("Crm.Signature", ["Crm.Signature.Controller", "Crm.signature.templates"]).component("signatureContact", {
  controller: "signatureContact",
  templateUrl: "src/signature/template/form-contact.html",
  bindings: {
    contact: "=",
    isCoacquereur: "<",
    onCopyAddress: "&",
    formName: "<",
    formObj: "="
  }
}).component("signaturePret", {
  controller: "signaturePret",
  templateUrl: "src/signature/template/form-pret.html",
  bindings: {
    pret: "=",
    formName: "<",
    formObj: "=",
    formDisabled: "="
  }
}).component("genererContrat", {
  controller: "genererContrat",
  templateUrl: "src/signature/generer-contrat.html",
  bindings: {
    transaction: "<"
  }
}).directive("fileModel", ["$parse", function ($parse) {
  return {
    restrict: "A",
    link: function (scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;
      element.bind("change", function () {
        scope.$apply(function () {
          modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module("contrats.Service", ["ngResource"])
/**
 * Service
 */
.factory("Contrat", ["$resource", "Config", function ($resource, Config) {
  var contratsApi = $resource(Config.API_BASE_URL + "/documents/reservation-contrats/:documentId", {
    documentId: "@documentId"
  }, {
    query: {
      isArray: false
    }
  });
  return contratsApi;
}]).factory("ContratSigne", ["$resource", "Config", function ($resource, Config) {
  var signaturesApi = $resource(Config.API_BASE_URL + "/signatures/reservation-contrats/:documentId", {
    documentId: "@documentId"
  }, {
    query: {
      isArray: false
    }
  });

  signaturesApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return signaturesApi;
}]).factory("GenererContrat", ["$resource", "Config", function ($resource, Config) {
  var contratsApi = $resource(Config.API_BASE_URL + "/documents/reservation-contrats?transaction_id=:transactionId", {
    transactionId: "@transactionId",
    timeout: 120000
  }, {
    query: {
      isArray: false
    }
  });
  return contratsApi;
}]).factory("ImportContrat", ["$resource", "Config", function ($resource, Config) {
  var importContratApi = $resource(Config.API_BASE_URL + "/documents/import-contrat-signed", {}, {
    upload: {
      method: "POST",
      headers: {
        "Content-Type": undefined
      },
      transformRequest: angular.identity
    }
  });
  return importContratApi;
}]).factory("DeleteContratSigned", ["$resource", "Config", function ($resource, Config) {
  var deleteContratApi = $resource(Config.API_BASE_URL + "/documents/import-contrat-signed/:id", {
    id: "@id"
  }, {
    delete: {
      method: "DELETE"
    }
  });
  return deleteContratApi;
}]);
/**
 * Module definition and dependencies
 */

angular.module('recommandes.Service', ['ngResource'])
/**
 * Service
 */
.factory('Recommandes', ['$resource', 'Config', function ($resource, Config) {
  var recommandesApi = $resource(Config.API_BASE_URL + '/recommandes/reservation-contrats/:recommandeContratId', {
    recommandeContratId: '@id'
  }, {
    query: {
      isArray: false
    }
  });

  recommandesApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return recommandesApi;
}]);
/**
 * Module definition and dependencies
 */

angular.module("signatures.Service", ["ngResource"])
/**
 * Service
 */
.factory("Signatures", ["$resource", "Config", function ($resource, Config) {
  var signaturesApi = $resource(Config.API_BASE_URL + "/signatures/reservation-contrats/:signContratId", {
    signContratId: "@id"
  }, {
    query: {
      isArray: false
    }
  });

  signaturesApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return signaturesApi;
}]).factory("RelancesSignatures", ["$resource", "Config", function ($resource, Config) {
  var signaturesApi = $resource(Config.API_BASE_URL + "/signatures/relances?transaction_document_signature_id=:transactionDocumentSignatureId", {
    transactionDocumentSignatureId: "@transactionDocumentSignatureId"
  }, {
    query: {
      isArray: false
    }
  });

  signaturesApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return signaturesApi;
}]).factory("CheckSignatureRequirements", ["$resource", "Config", function ($resource, Config) {
  const api = $resource(Config.API_BASE_URL + "/private/documents/:documentId/check-signature-requirements", {
    documentId: "@documentId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("SignatureSendEmailSigner", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/documents/:transactionDocumentSignatureId/signers", {
    transactionId: "@transactionId",
    transactionDocumentSignatureId: "@transactionDocumentSignatureId",
    signer_id: "@signerId"
  }, {
    query: {
      isArray: false
    }
  });

  api.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return api;
}]);
angular.module('Crm.signature.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/signature/generer-contrat.html','<div class="panel panel-default"><div class="panel-heading d-flex justify-content-between"><h3 class="panel-title">G\xE9n\xE9ration et validation de contrat</h3> <button class="btn-no-style" tooltip-placement="left" uib-tooltip="Actualiser" ng-disabled="$ctrl.disabledRefreshTransactionProcedure" ng-click="$ctrl.refreshTransactionProcedure()" ng-if="$ctrl.transaction.signature_procedure_status > 0"><span class="icon-refresh"></span></button></div><div class="panel-body"><div ng-if="$ctrl.configCommercialisateur.contrat_reservation_generate_enabled"><div class="row"><div class="col-xs-12"><p class="mb-1" ng-if="$ctrl.transaction.contrat_date_initialisation && $ctrl.transaction.contrat_date_initialisation.date"> {{ $ctrl.transaction.signature_procedure_status == 2 ? \'Contrat import\xE9 le\' : \'Contrat g\xE9n\xE9r\xE9 le\' }} : {{ $ctrl.transaction.contrat_date_initialisation.date | moment:\'DD/MM/YYYY\' }}</p><p class="mb-1" ng-if="$ctrl.transaction.contrat_date_signature && $ctrl.transaction.contrat_date_signature.date"> Contrat sign\xE9 par le client le {{ $ctrl.transaction.contrat_date_signature.date | moment:\'DD/MM/YYYY\' }}</p><div class="btn-container"><btn-generer-contrat class="btn-content" btn-type="\'generer-contrat\'" transaction="$ctrl.transaction"></btn-generer-contrat><btn-re-generer-contrat class="btn-content" btn-type="\'re-generer-contrat\'" transaction="$ctrl.transaction"></btn-re-generer-contrat><div class="btn-content" ng-if="$ctrl.transaction.processus_generating == 0 || !$ctrl.transaction.processus_generating"> <button class="btn btn-secondary" ng-click="$ctrl.openImportContratModal()" ng-disabled="$ctrl.importContratClicked || !$ctrl.transaction.id"> <span ng-if="!$ctrl.importContratLoading && !$ctrl.transaction.contract_signed_document_url">Importer un contrat sign\xE9</span> <span ng-if="!$ctrl.importContratLoading && $ctrl.transaction.contract_signed_document_url">Mettre \xE0 jour le contrat sign\xE9</span><span ng-if="$ctrl.importContratLoading"><i class="fa fa-spinner fa-spin"></i> Importation en cours...</span></button> <button class="btn btn-danger ml-2" ng-if="$ctrl.transaction.contract_signed_document_url" ng-click="$ctrl.confirmDeleteSignedContract()" ng-disabled="$ctrl.deleteContratClicked"> <span ng-if="!$ctrl.deleteContratLoading">Supprimer le contrat sign\xE9</span><span ng-if="$ctrl.deleteContratLoading"><i class="fa fa-spinner fa-spin"></i> Suppression...</span></button></div><btn-demarrer-signature class="btn-content" transaction="$ctrl.transaction" is-check-signature-requirements="true" signature-requirements="$ctrl.signatureRequirements" is-notification-contrat-generer="true"></btn-demarrer-signature><btn-abandonner-signature class="btn-content" transaction="$ctrl.transaction"></btn-abandonner-signature><btn-valider-contrat class="btn-content" transaction="$ctrl.transaction" my-validator="$ctrl.myValidator" my-reservant="$ctrl.myReservant" is-notification-contrat-generer="true"></btn-valider-contrat></div><div><files files="$ctrl.contratFiles"></files><div ng-if="$ctrl.transaction && $ctrl.transaction.procedure  && ($ctrl.transaction.procedure.status === \'active\' || $ctrl.transaction.procedure.status === \'ongoing\')"><signatures-signers transaction="$ctrl.transaction"></signatures-signers></div><files ng-if="$ctrl.transaction && $ctrl.transaction.signature_procedure_status && $ctrl.transaction.signature_procedure_status != 2" files="$ctrl.contratFilesAcquereur" files-title="Acqu\xE9reur" add-class-title="mt-2"></files><files ng-if="$ctrl.transaction && $ctrl.transaction.signature_procedure_status && $ctrl.transaction.signature_procedure_status != 2" files="$ctrl.contratFilesCoAcquereur" files-title="Co-acqu\xE9reur" add-class-title="mt-2"></files></div></div><div class="col-xs-12 mt-2"><div class="alert alert-info" ng-if="$ctrl.signatureRequirements && $ctrl.signatureRequirements.valid === false"><ul><li ng-repeat="message in $ctrl.signatureRequirements.messages"> {{ message }}</li></ul></div><div ng-if="$ctrl.message && $ctrl.message.length > 0">{{$ctrl.message}}</div><div ng-if="$ctrl.transaction.signature_procedure_status && $ctrl.myValidator.status !== \'active\' && !$ctrl.procedure.signature_procedure_status"><p class="alert alert-info"><statut-signature statut="$ctrl.transaction.signature_procedure_status"></statut-signature></p></div><div class="btn-container justify-end"><div ng-if="$ctrl.transaction.signature_procedure_status == \'35\'\r\n                        && $ctrl.myValidator.status !== \'active\'\r\n                        && $ctrl.transaction.recommande_enabled"> <button class="btn btn-tertiary" ng-click="$ctrl.envoieAR($ctrl.transaction)" ng-disabled="$ctrl.submitClicked"> <span ng-if="!$crtl.loading && !$crtl.succes">Envoyer AR24 manuellement</span></button></div></div><div ng-if="$ctrl.transaction.signature_procedure_status && $ctrl.transaction.signature_procedure_status != 2"><p class="alert alert-info"><statut-signature statut="$ctrl.transaction.signature_procedure_status"></statut-signature></p></div><div ng-class="{\'hidden\': !$ctrl.btnSendAr}" class="btn-container justify-end" style="justify-content:end"><div ng-if="[40,42,45,50,52,55,60,65].includes($ctrl.transaction.signature_procedure_status)\r\n                        && $ctrl.myValidator.status !== \'active\'\r\n                        && $ctrl.transaction.recommande_enabled"> <button class="btn btn-tertiary" ng-click="$ctrl.restartAR($ctrl.transaction)" ng-disabled="$ctrl.submitClicked"> <span ng-if="!$crtl.loading && !$crtl.succes">Relancer un nouvel envoi AR24</span></button></div></div><p class="alert alert-info" ng-if="$ctrl.transaction.signature_procedure_status === 50 && $ctrl.transaction.purge_end_date && $ctrl.transaction.purge_end_date.date"> La transaction est en SRU jusqu\'au {{ $ctrl.transaction.purge_end_date.date | moment:\'DD/MM/YYYY\' }}</p></div></div><div class="row" ng-if="$ctrl.validators.length > 0 && $ctrl.transaction.signature_procedure_status != 2"><div class="col-xs-12"><h4>Validation</h4><table class="table table-striped table-bordered table-validators"><thead><tr><th></th><th>Rang</th><th>Nom</th><th>Date</th><th>Motif de refus</th></tr></thead><tbody><tr ng-repeat="validator in $ctrl.validators track by validator.id"><td> <span class="material-icons success" ng-if="validator.status == \'done\'">check</span> <span class="material-icons refused" ng-if="validator.status == \'refused\'">close</span></td><td> {{ validator.position }}</td><td> {{ validator.firstname }} {{ validator.lastname }}</td><td> {{ validator.finishedAt | moment : \'DD/MM/YYYY\' }}</td><td> {{ validator.comment }}</td></tr></tbody></table></div></div></div><div class="row" ng-if="!$ctrl.configCommercialisateur.contrat_reservation_generate_enabled"><div class="col-xs-12"><p>L\'option suivi de contrat n\'est pas activ\xE9e.</p><p> Contactez votre responsable commercial pour b\xE9n\xE9ficier d\'un essai.</p></div></div></div></div>');
$templateCache.put('src/signature/modal-delete-contrat.html','<div class="modal-header"><h3 class="modal-title h4">Confirmer la suppression</h3></div><div class="modal-body"> \xCAtes-vous s\xFBr de vouloir supprimer le contrat sign\xE9 ? Cette action est irr\xE9versible.</div><div class="modal-footer"> <button class="btn btn-default" ng-click="$ctrl.annuler()">Annuler</button> <button class="btn btn-danger" ng-click="$ctrl.confirmer()">Supprimer</button></div>');
$templateCache.put('src/signature/modal-import-contrat.html','<div class="modal-header"> <button type="button" class="close" ng-click="$dismiss()"> <span>&times;</span></button><h3 class="modal-title h4" id="modal-title">Importer un contrat</h3></div><div class="modal-body" id="modal-body"><p>Veuillez s\xE9lectionner un document Word ou PDF \xE0 importer comme contrat.</p><div class="form-group"> <label for="fileInput">Fichier (Word ou PDF uniquement)</label> <input type="file" id="fileInput" accept=".doc,.docx,.pdf" file-model="$ctrl.contratFile" class="form-control"></div><div class="alert alert-info" ng-if="$ctrl.transaction.signature_procedure_status > 0"><p><i class="fa fa-info-circle"></i> Attention: Un contrat existe d\xE9j\xE0 pour cette transaction. L\'importation d\'un nouveau contrat remplacera le contrat existant.</p></div></div><div class="modal-footer"> <button class="btn btn-danger" type="button" ng-click="$ctrl.annuler()">Annuler</button> <button class="btn btn-primary" type="button" ng-click="$ctrl.importerContrat()" ng-disabled="!$ctrl.contratFile" promise-btn> <span class="btn-text">Importer</span></button></div>');
$templateCache.put('src/signature/modal-restartAR.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Nouvel envoi AR24</h3></div><div class="modal-body" id="modal-body"> Renouveler l\'envoi d\'un <strong>AR24</strong> pour cette transaction ?<br/></div><div class="modal-footer"> <button class="btn btn-danger" type="button" ng-click="$ctrl.annuler()">Annuler</button> <button class="btn btn-primary" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Envoyer</span></button></div>');
$templateCache.put('src/signature/modal-signature.html','<div class="modal-header"> <button type="button" class="close" ng-click="$dismiss()"> <span>&times;</span></button><h3 class="modal-title h4" id="modal-title">D\xE9marrer la signature</h3></div><div class="modal-body" id="modal-body"> Veuillez choisir le niveau de preuve de la signature.<div class=" mt-1"><ul class="unstyled"><li ng-repeat="proof in $ctrl.proofOptions"> <input type="radio" id="proof_level_{{$index}}" name="proof_level" ng-value="proof.value" ng-model="$parent.selectedProofLevel"/> <label for="proof_level_{{$index}}" class="radio">{{ proof.name }}</label></li></ul></div><div class="relative mt-2"> <input type="checkbox" class="checkbox" id="valid_contrat" ng-model="$ctrl.valid_contrat"/> <label for="valid_contrat" class="checkbox">J\'ai lu et v\xE9rifi\xE9 le contrat g\xE9n\xE9r\xE9. Je confirme que le contrat est conforme et qu\'il peut \xEAtre envoy\xE9 par mail pour signature \xE9lectronique.</label></div></div><div class="modal-footer"> <button class="btn btn-danger" type="button" ng-click="$ctrl.annuler()"> Annuler</button> <button class="btn btn-primary" type="button" ng-click="$ctrl.valider()" promise-btn> <span class="btn-text" ng-disabled="!$ctrl.valid_contrat">Valider</span></button></div>');
$templateCache.put('src/signature/modal-startLRE.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Envoyer un recommand\xE9</h3></div><div class="modal-body" id="modal-body"> Envoyer un recommand\xE9 \xE0 <strong>{{ $ctrl.transaction.client_nom }} {{ $ctrl.transaction.client_prenom }}</strong> pour le lot <strong>{{ $ctrl.transaction.lot_nom }}</strong> du programme <strong>{{ $ctrl.transaction.programme_nom }}</strong>.</div><div class="modal-footer"> <button class="btn btn-danger" type="button" ng-click="$ctrl.annuler()">Annuler</button> <button class="btn btn-primary" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Envoyer</span></button></div>');
$templateCache.put('src/signature/genererContrat/annexes.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Annexes</h2></div><div class="col-xs-12 col-md-12"><div class="transaction-documents"><div class="clearfix" ng-class="{\'hiddenPager\' : $ctrl.listDocuments._settings.total <= 10}" ng-show="!$ctrl.loading"><div class="content-results"><table ng-table="$ctrl.listDocuments" class="table table-striped table-bordered table-hover table-vmiddle"><tr ng-repeat="item in $data" ng-if="$data.length > 0"><td data-title="\'Ordre\'" style="width: 80px; text-align: center;"> <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.moveUp($index)" ng-disabled="$first" title="Monter"><i class="fa fa-arrow-up"></i></button> <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.moveDown($index)" ng-disabled="$last" title="Descendre"><i class="fa fa-arrow-down"></i></button></td><td data-title="\'Nom\'" ng-attr-title="{{ item.nom }}"> {{ item.nom }}</td><td data-title="\'Titre\'" ng-attr-title="{{ item.titre }}"> {{ item.titre }}</td><td data-title="\'Cat\xE9gorie\'" ng-attr-title="{{ item.categorie_label }}"> {{ item.categorie_label }}</td><td><toggle-with-handle-change value="$ctrl.isDocumentSelected(item)" handle-change="$ctrl.selectionDocuments(item)"></toggle-with-handle-change></td></tr><tr ng-if="$data.length === 0"><td colspan="10"><p> Aucun document</p></td></tr></table></div></div><div class="scroll-footer" style="text-align:center;" ng-show="$ctrl.loading" ng-if="!$ctrl.btnShow || $ctrl.display"> <span>En chargement&nbsp;&nbsp;&nbsp;<img ng-src="{{$root.pathImageAjaxLoader}}"/></span></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/contact-conjoint-coacquereur.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">V\xE9rifiez / Completez les coordonn\xE9es</h2></div><div class="col-xs-12 col-md-12"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Acqu\xE9reur</span><div class="d-flex sign-form-toggle"> Soci\xE9t\xE9<toggle value="$ctrl.isSociete"></toggle></div></h3><signature-contact ng-if="!$ctrl.isSociete" contact="$ctrl.contact" form-name="\'formValidAcquereur\'" form-obj="$ctrl.formValidAcquereur"></signature-contact><div ng-if="$ctrl.isSociete" class="row"><div class="col-xs-12 mb-05"> <label class="control-label force-label">Raison sociale :</label> <input placeholder="Raison sociale" class="form-control" type="text" ng-model="$ctrl.societe.raisonSocial"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Si\xE8ge social :</label> <input placeholder="Si\xE8ge social" class="form-control" type="text" ng-model="$ctrl.societe.siegeSocial"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Repr\xE9sent\xE9e par :</label> <input placeholder="Repr\xE9sent\xE9e par" class="form-control" type="text" ng-model="$ctrl.societe.representer"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">En qualit\xE9 de :</label> <input placeholder="En qualit\xE9 de" class="form-control" type="text" ng-model="$ctrl.societe.qualiteDe"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Date de naissance :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.societe.date_naissance" as-date ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" alt-input-formats="altInputFormats" placeholder="Date de naissance" readonly/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Lieu de naissance :</label> <input placeholder="Lieu de naissance" class="form-control" type="text" ng-model="$ctrl.societe.lieu_naissance"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Adresse :</label> <input placeholder="Adresse" class="form-control" type="text" ng-model="$ctrl.societe.adresse"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Code postal :</label> <input placeholder="Code Postal" class="form-control" type="text" ng-model="$ctrl.societe.societeCodePostal"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Ville :</label> <input placeholder="Ville" class="form-control" type="text" ng-model="$ctrl.societe.societeVille"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Pays :</label> <input placeholder="Pays" class="form-control" type="text" ng-model="$ctrl.societe.societePays"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">T\xE9l\xE9phone :</label> <input placeholder="T\xE9l\xE9phone" class="form-control" type="text" ng-model="$ctrl.societe.societeTelephone"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Portable :</label> <input placeholder="Portable" class="form-control" type="text" ng-model="$ctrl.societe.societePortable"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Email :</label> <input placeholder="Email" class="form-control" type="email" ng-model="$ctrl.societe.societeEmail"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Num\xE9ro RCS :</label> <input placeholder="Num\xE9ro RCS " class="form-control" type="text" ng-model="$ctrl.societe.societeRCS"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Ville RCS :</label> <input placeholder="Ville RCS " class="form-control" type="text" ng-model="$ctrl.societe.villeRCS"/></div><div class="col-xs-12 mb-05"><div class="acquiert-pourcent-container bold"> Acquiert <input class="form-control in-text orange" type="number" pattern="+(.d{2})?" min="0" max="100" ng-model="$ctrl.societe.acquiert_pourcent"/> % du bien</div></div></div></div><div class="col-xs-12"><div class="separate"></div></div><div class="col-xs-12 col-md-12"><div ng-if="!$ctrl.isSociete"><div class=""><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Co-acqu\xE9reur</span><div class="d-flex sign-form-toggle"><toggle value="$ctrl.isCoAcquereur"></toggle></div></h3></div><div ng-if="$ctrl.isCoAcquereur"><div class="row"><div class="col-xs-12" ng-class="{\'col-md-9\': $ctrl.selectCoAcquereur.id }"><select-contact contact="$ctrl.selectCoAcquereur"></select-contact></div><div class="col-xs-12" ng-class="{\'col-md-3\': $ctrl.selectCoAcquereur.id }" ng-if="$ctrl.selectCoAcquereur.id"> <button class="btn btn-secondary" ng-click="$ctrl.resetCoAcquereur()">Effacer</button></div></div><div class="row mt-2"><div class="col-xs-12"><signature-contact is-coacquereur="1" on-copy-address="$ctrl.setSameAddress()" contact="$ctrl.co_acquereur" form-name="\'formValidCoAcquereur\'" form-obj="$ctrl.formValidCoAcquereur"></signature-contact></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/depot-garantie.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">D\xE9pot de garantie</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-6"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Informations de paiement</span></h3></div></div><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group row" ng-if="$ctrl.configsContratReservation.depot_garantie_numero_cheque && $ctrl.configsContratReservation.depot_garantie_numero_cheque === true"> <label class="control-label col-xs-12" for="depot_cheque">Num\xE9ro de ch\xE8que :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.depot.cheque" class="form-control" id="depot_cheque" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group row" ng-if="$ctrl.configsContratReservation.depot_garantie_banque && $ctrl.configsContratReservation.depot_garantie_banque === true"> <label class="control-label col-xs-12" for="depot_banque">Banque :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.depot.banque" class="form-control" id="depot_banque" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group row" ng-if="$ctrl.configsContratReservation.depot_garantie_montant && $ctrl.configsContratReservation.depot_garantie_montant === true"> <label class="control-label col-xs-12" for="depot_montant">Montant (en \u20ACuros) :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.depot.montant" class="form-control" id="depot_montant" ng-keyup="$ctrl.format(\'depot\',\'montant\')" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group row" ng-if="$ctrl.configsContratReservation.depot_garantie_date_versement && $ctrl.configsContratReservation.depot_garantie_date_versement === true"> <label class="control-label col-xs-12" for="depot_date_versement">Date du versement :</label><div class="col-xs-12"><div class="input-group"> <input id="depot_date_versement" type="text" as-date class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.depot.date_versement" ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" readonly/><span class="input-group-addon"><span class="glyphicon glyphicon-time" ng-click="openDatePickerEnd"></span></span></div></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/financement.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Financement</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_emprunteur && $ctrl.configsContratReservation.financement_emprunteur === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Emprunteur</span></h3><div class="row"><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_emprunteur_salaire_net_annuel && $ctrl.configsContratReservation.financement_emprunteur_salaire_net_annuel === true"> <label class="control-label">Salaire net annuel :</label> <input placeholder="Salaire net annuel" class="form-control" name="salaire" type="number" ng-model="$ctrl.financement.acquereur.salaire"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_emprunteur_bic && $ctrl.configsContratReservation.financement_emprunteur_bic === true"> <label class="control-label">BIC, BNC, BA :</label> <input placeholder="BIC, BNC, BA" class="form-control" name="bic" type="number" ng-model="$ctrl.financement.acquereur.bic"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_emprunteur_revenus_fonciers_bruts && $ctrl.configsContratReservation.financement_emprunteur_revenus_fonciers_bruts === true"> <label class="control-label">Revenus fonciers bruts :</label> <input placeholder="Revenus fonciers bruts" class="form-control" name="revenus" type="number" ng-model="$ctrl.financement.acquereur.revenus_fonciers"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_emprunteur_autre && $ctrl.configsContratReservation.financement_emprunteur_autre === true"> <label class="control-label">Autre :</label> <input placeholder="Autre" class="form-control" name="autre" type="number" ng-model="$ctrl.financement.acquereur.autre"/></div></div></div><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_co_emprunteur && $ctrl.configsContratReservation.financement_co_emprunteur === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block  sign-tabs-subtitle">Co-emprunteur</span></h3><div class="row"><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_co_emprunteur_salaire_net_annuel && $ctrl.configsContratReservation.financement_co_emprunteur_salaire_net_annuel === true"> <label class="control-label">Salaire net annuel :</label> <input placeholder="Salaire net annuel" class="form-control" name="salaire" type="number" ng-model="$ctrl.financement.co_acquereur.salaire"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_co_emprunteur_bic && $ctrl.configsContratReservation.financement_co_emprunteur_bic === true"> <label class="control-label">BIC, BNC, BA :</label> <input placeholder="BIC, BNC, BA" class="form-control" name="bic" type="number" ng-model="$ctrl.financement.co_acquereur.bic"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_co_emprunteur_revenus_fonciers_bruts && $ctrl.configsContratReservation.financement_co_emprunteur_revenus_fonciers_bruts === true"> <label class="control-label">Revenus fonciers bruts :</label> <input placeholder="Revenus fonciers bruts" class="form-control" name="revenus" type="number" ng-model="$ctrl.financement.co_acquereur.revenus_fonciers"/></div><div class="col-xs-12 mb-05" ng-if="$ctrl.configsContratReservation.financement_co_emprunteur_autre && $ctrl.configsContratReservation.financement_co_emprunteur_autre === true"> <label class="control-label">Autre :</label> <input placeholder="Autre" class="form-control" name="autre" type="number" ng-model="$ctrl.financement.co_acquereur.autre"/></div></div></div></div><div class="row mt-1" ng-if="$ctrl.configsContratReservation.financement_cout_operation && $ctrl.configsContratReservation.financement_cout_operation === true"><div class="col-xs-12 col-md-6"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Co\xFBt de l\'op\xE9ration</span></h3></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_estimation_frais_acquisition && $ctrl.configsContratReservation.financement_estimation_frais_acquisition === true"><div class="form-group row"> <label class="control-label col-xs-12" for="frais_aquisition">Estimation frais d\'acquisition :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.financement.acteAquistaion" class="form-control" id="frais_aquisition" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_estimation_frais_hypotheque && $ctrl.configsContratReservation.financement_estimation_frais_hypotheque === true"><div class="form-group row"> <label class="control-label col-xs-12" for="frais_hypotheque">Estimation frais d\'hypoth\xE8que :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.financement.acteHypotheque" class="form-control" id="frais_hypotheque" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_estimation_frais_copropriete && $ctrl.configsContratReservation.financement_estimation_frais_copropriete === true"><div class="form-group row"> <label class="control-label col-xs-12" for="frais_copropriete">Estimation frais de copropri\xE9t\xE9 :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.financement.acteCopropriete" class="form-control" id="frais_copropriete" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_fonds_propres && $ctrl.configsContratReservation.financement_fonds_propres === true"><div class="form-group row"> <label class="control-label col-xs-12" for="frais_propre">Fonds Propres :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.financement.actePropres" class="form-control" id="frais_propres" placeholder=""/></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.financement_revente_bien && $ctrl.configsContratReservation.financement_revente_bien === true"><div class="form-group row"> <label class="control-label col-xs-12" for="frais_aquisition">Revente d\'un bien :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.financement.acteBien" class="form-control" id="frais_Bien" placeholder=""/></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/fiscalite.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Fiscalit\xE9</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-4"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Intention d\'achat</span></h3><div class=""><div class="intention-achat-block"> <label>Acquisition en r\xE9sidence principale :</label><toggle-with-handle-change value="$ctrl.fiscalite.acquisition_residence_principale" handle-change="$ctrl.handleChangeIntentionAchat(\'acquisition_residence_principale\')"></toggle-with-handle-change></div><div class="intention-achat-block"> <label>Investissement en r\xE9sidence secondaire :</label><toggle-with-handle-change value="$ctrl.fiscalite.investissement_residence_secondaire" handle-change="$ctrl.handleChangeIntentionAchat(\'investissement_residence_secondaire\')"></toggle-with-handle-change></div><div class="intention-achat-block"> <label>Investissement locatif Pinel :</label><toggle-with-handle-change value="$ctrl.fiscalite.impot" handle-change="$ctrl.handleChangeIntentionAchat(\'impot\')"></toggle-with-handle-change></div><div class="intention-achat-block"> <label>Acquisition pour un investissement locatif hors dispositif Pinel :</label><toggle-with-handle-change value="$ctrl.fiscalite.acquisition_investissement_hors_pinel" handle-change="$ctrl.handleChangeIntentionAchat(\'acquisition_investissement_hors_pinel\')"></toggle-with-handle-change></div><div class="intention-achat-block"> <label>Investissement locatif en meubl\xE9 :</label><toggle-with-handle-change value="$ctrl.fiscalite.investissement_locatif_meuble" handle-change="$ctrl.handleChangeIntentionAchat(\'investissement_locatif_meuble\')"></toggle-with-handle-change></div></div></div><div class="col-xs-12 col-md-4"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Frais et commissions</span></h3><div class="row mt-1"><div class="col-xs-12"> <label class="control-label">Frais et commissions directs et indirects HT :</label></div><div class="col-xs-12"> <input type="number" ng-model="$ctrl.fiscalite.commissions" class="form-control" id="commissions" placeholder=""/></div></div><div class="row mt-1"><div class="col-xs-12"> <label class="control-label">Pourcentage du prix de revient :</label></div><div class="col-xs-12"> <input type="number" ng-model="$ctrl.fiscalite.bien" class="form-control" id="commissions" placeholder=""/></div></div></div><div class="col-xs-12 col-md-4" ng-if="$ctrl.configsContratReservation.fiscalite_caracteristiques_contrat && $ctrl.configsContratReservation.fiscalite_caracteristiques_contrat === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Caract\xE9ristiques du contrat</span></h3><div class="row" ng-if="$ctrl.configsContratReservation.fiscalite_taux_tva_appliquee && $ctrl.configsContratReservation.fiscalite_taux_tva_appliquee === true"><div class="col-xs-12"> <label>Taux de TVA :</label></div><div class="col-xs-12"> <input type="number" ng-model="$ctrl.fiscalite.tva" class="form-control" id="commissions" placeholder=""/></div></div><div class="row" ng-class="{ \'mt-1\': $ctrl.configsContratReservation.fiscalite_taux_tva_appliquee && $ctrl.configsContratReservation.fiscalite_taux_tva_appliquee === true }" ng-if="$ctrl.configsContratReservation.fiscalite_indice_bt01 && $ctrl.configsContratReservation.fiscalite_indice_bt01 === true"><div class="col-xs-12"> <label>Indice BT 01:</label></div><div class="col-xs-12"> <input type="number" ng-model="$ctrl.fiscalite.indice_bt01" class="form-control" id="indice_bt01" placeholder=""/></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/lot.html','<div class="row tab-lot"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Lot</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-12 mb-2"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Lot principal</span></h3><p class="h4"> {{ $ctrl.lot.nature }} {{ $ctrl.lot.type }} r\xE9f\xE9rence : {{ $ctrl.lot.nom }}</p><p></p><ul class="unstyled details-lot lh-3"><li ng-if="$ctrl.lot.pieces"> Nombre de pi\xE8ces : <span class="pull-right">{{ $ctrl.lot.pieces }}</span></li><li ng-if="$ctrl.lot.surface"> Surface habitable: <span class="pull-right">{{ $ctrl.lot.surface }} m<sup>2</sup></span></li><li ng-if="$ctrl.lot.surface_terrasse > 0"> Surface terrasse : <span class="pull-right">{{ $ctrl.lot.surface_terrasse }}</span></li><li ng-if="$ctrl.lot.etage"> \xC9tage : <span class="pull-right">{{ $ctrl.lot.etage }}</span></li><li class="total"> Prix de vente total TTC <span class="pull-right">{{ $ctrl.transactionDetails.prix | currency:$ctrl.lot.devise_unite:0 }}</span></li></ul></div></div><div class="row mt-1" ng-if="$ctrl.lot.lots_annexes"><div class="col-xs-12 col-md-12"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Lot(s) annexe(s)</span></h3><div ng-repeat="annexe in $ctrl.lot.lots_annexes" class="mt-1"><p class="h4"> {{ annexe.type }} {{ annexe.nom }} r\xE9f\xE9rence : {{ annexe.nom_ref }}</p><p></p><ul class="unstyled details-lot"><li ng-if="$ctrl.lot.surface"> Surface : <span class="pull-right">{{ annexe.surface }} m<sup>2</sup></span></li><li class="total"> Prix de vente : <span class="pull-right">{{ annexe.prix_vente_total | currency:\'\u20AC\':0 }}</span></li></ul></div><div class="mt-2"></div><h3 class="text-right mt-2"> Prix total : {{ $ctrl.additionnalLots() | currency:\'\u20AC\':0 }}</h3></div></div></div><div class="col-xs-12 col-md-6"><div class="row"><div class="col-xs-12" ng-if="$ctrl.configsContratReservation.lot_pack && $ctrl.configsContratReservation.lot_pack === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Pack</span></h3><div class="form-group row"> <label class="control-label col-xs-12" for="pack-label">Label :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.pack.label" class="form-control" id="pack-label" placeholder=""/></div></div><div class="form-group row mt-1"> <label class="control-label col-xs-12" for="pack-prix">Prix :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.pack.prix" class="form-control" id="pack-prix" placeholder=""/></div></div></div></div></div><div class="col-xs-12 col-md-6"><div class="row"><div class="col-xs-12" ng-if="$ctrl.configsContratReservation.lot_option && $ctrl.configsContratReservation.lot_option === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Option</span></h3><div class="form-group row"> <label class="control-label col-xs-12" for="option-label">Label :</label><div class=" col-xs-12"> <input type="text" ng-model="$ctrl.option.label" class="form-control" id="option-label" placeholder=""/></div></div><div class="form-group row mt-1"> <label class="control-label col-xs-12" for="option-prix">Prix :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.option.prix" class="form-control" id="option-prix" placeholder=""/></div></div></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6 mt-2" ng-if="$ctrl.configsContratReservation.lot_conditions_particulieres && $ctrl.configsContratReservation.lot_conditions_particulieres === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Conditions particuli\xE8res</span></h3><div class="form-group"><textarea class="form-control" rows="5" name="condition_particuliere" type="text" ng-model="$ctrl.conditions_particulieres"></textarea></div></div><div class="col-xs-12 col-md-6 mt-2" ng-if="$ctrl.configsContratReservation.lot_designation && $ctrl.configsContratReservation.lot_designation === true"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">D\xE9signation</span></h3><div class="form-group"><textarea class="form-control" rows="5" name="note" type="text" ng-model="$ctrl.description_bien"></textarea></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/notaire.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Notaire</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12 col-md-6"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Informations</span></h3></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.notaire_date_reception_acte && $ctrl.configsContratReservation.notaire_date_reception_acte === true"><div class="form-group row"> <label class="control-label col-xs-12" for="date_reception_acte ">Date r\xE9ception acte notaire :</label><div class="col-xs-12"><div class="input-group"> <input id="date_reception_acte " type="text" as-date class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.notaire.date_reception_acte" ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" readonly/><span class="input-group-addon"><span class="glyphicon glyphicon-time" ng-click="openDatePickerEnd"></span></span></div></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.notaire_participation && $ctrl.configsContratReservation.notaire_participation === true"><div class="form-group row"> <label class="control-label col-xs-12" for="notaire_participation">Notaire en participation :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.notaire.participation" class="form-control" id="notaire_participation" placeholder=""></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.notaire_date_livraison_previsionnelle && $ctrl.configsContratReservation.notaire_date_livraison_previsionnelle === true"><div class="form-group row"> <label class="control-label col-xs-12" for="notaire_date_previsionnelle">Date de livraison pr\xE9visionnelle :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.notaire.date_livraison_previs" class="form-control" id="notaire_date_previsionnelle" placeholder=""></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/pret.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">Pr\xEAt(s)</h2></div><div class="col-xs-12 col-md-12"><div class="row"><div class="col-xs-12"><div class="d-flex"><div ng-repeat="item in $ctrl.optionsGenererContrat" class="mr-2"> <input type="radio" id="item_{{$index}}" name="option-generer-contrat" ng-value="item.value" ng-model="$parent.$ctrl.selectedoptionsGenererContrat"/> <label for="item_{{$index}}" class="radio large-font-size">{{ item.name }}</label></div></div></div></div><div class="row mt-2"><div class="col-xs-12" ng-if="$ctrl.selectedoptionsGenererContrat"><div class="row container-prets"><div class="col-xs-12 col-md-6"><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Pr\xEAt 1</span></h3><signature-pret pret="$ctrl.pret" form-name="\'pret1\'" form-obj="$ctrl.formObjPret1"></signature-pret></div><div class="col-xs-12 col-md-6"><h3 class="p-relative no-bg font-2"> <span class="d-block text-center sign-tabs-subtitle">Pr\xEAt 2</span><div class="d-flex sign-form-toggle"><toggle value="$ctrl.isPret2"></toggle></div></h3><signature-pret pret="$ctrl.pret2" form-name="\'pret2\'" form-disabled=!$ctrl.isPret2 form-obj="$ctrl.formObjPret2"></signature-pret></div></div></div></div><div class="row mt-1"><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.pret_differe_amortissement && $ctrl.configsContratReservation.pret_differe_amortissement === true"><div><div><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">Diff\xE9r\xE9 d\'amortissement</span></h3><div class="form-group"> <label class="control-label" for="type_amortissement">Type :</label><div> <select class="form-control" id="type_amortissement" name="type_amortissement" ng-model="$ctrl.amortissement.type"><option value="">Type</option><option value="Partiel">Partiel</option><option value="Total">Total</option></select></div></div><div class="form-group"> <label class="control-label" for="duree_mois">Dur\xE9e en mois :</label><div> <input type="number" ng-model="$ctrl.amortissement.duree" class="form-control" id="duree_mois" placeholder=""/></div></div></div></div></div><div class="col-xs-12 col-md-6" ng-if="$ctrl.configsContratReservation.pret_delai_obtention && $ctrl.configsContratReservation.pret_delai_obtention === true"><div><div><h3 class="p-relative no-bg font-2 p-0"> <span class="d-block sign-tabs-subtitle">D\xE9lai pour obtention du pr\xEAt</span></h3><div class="form-group"> <label class="control-label" for="obtention_mois">Dur\xE9e en mois :</label><div> <input type="number" ng-model="$ctrl.obtention.duree" class="form-control" id="obtention_mois" placeholder=""/></div></div></div></div></div></div></div></div>');
$templateCache.put('src/signature/genererContrat/signature.html','<div class="row"><div class="col-xs-12 col-md-12"><h2 class="mt-05 text-center sign-tabs-title">G\xE9n\xE9ration du contrat</h2></div></div><div class="row tab-signature"><div class="col-xs-12 col-md-12 col-btn mt-3"><div class="sign-form-btn text-center"> <button class="btn btn-secondary btn-loader" type="submit" ng-click="$ctrl.valider()" promise-btn style="height:auto"> <span class="btn-text">G\xE9n\xE9rer le contrat</span></button></div></div></div>');
$templateCache.put('src/signature/template/form-contact.html','<form name="{{$ctrl.formName}}" novalidate><div class="row" ng-init="$ctrl.initForm()"><div class="col-xs-12 col-sm-4 content-avatar" style="display:none"><div class="avatar mt0" ng-if="$ctrl.contact.image" ngf-background="$ctrl.contact.image"> <button type="file" class="btn btn--photo" accept="image/*" ngf-select="$ctrl.uploadFiles($file, $invalidFiles)" ngf-resize-if="$width > 200 || $height > 200" ngf-resize="{width: 200, quality: .8, type: \'image/jpeg\'}" ngf-max-height="5500" ngf-fix-orientation="true" ngf-max-size="8MB"> <i class="material-icons">linked_camera</i></button></div><div class="avatar mt0" ng-if="!$ctrl.contact.image"> <i class="material-icons profil-icon">person</i> <button type="file" class="btn btn--photo" accept="image/*" ngf-select="$ctrl.uploadFiles($file, $invalidFiles)" ngf-resize-if="$width > 200 || $height > 200" ngf-resize="{width: 200, quality: .8, type: \'image/jpeg\'}" ngf-max-height="5500" ngf-fix-orientation="true" ngf-max-size="8MB"> <i class="material-icons">linked_camera</i></button></div> <input type="hidden" ng-model="$ctrl.contact.image"/></div><div class="col-xs-12 col-sm-12"><div class="row"><div ng-style="{\'display\': $ctrl.isCoacquereur===1 ? \'block\' : \'none\'}" class="col-xs-12 mb-05"> <input id="checkbox1{{$id}}" type="checkbox" ng-model="$ctrl.contact.isConjoint"/> <label class="checkbox" for="checkbox1{{$id}}">Conjoint de l\'acqu\xE9reur</label></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Civilit\xE9 :</label> <select class="form-control" ng-model="$ctrl.contact.civilite" ng-init="$ctrl.contact.civilite"><option value="M">Monsieur</option><option value="F">Madame</option><option value="MF">Monsieur et Madame</option></select></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Nom * :</label> <input placeholder="Nom *" class="form-control" name="nom" type="text" ng-model="$ctrl.contact.nom" ng-required="true" required/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Nom de jeune fille :</label> <input placeholder="Nom de jeune fille" class="form-control" name="nom" type="text" ng-model="$ctrl.contact.nom_jeune_fille"/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Pr\xE9nom * :</label> <input placeholder="Pr\xE9nom *" class="form-control col-xs-12" name="prenom" type="text" ng-model="$ctrl.contact.prenom" ng-required="true" required/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Deuxi\xE8me pr\xE9nom :</label> <input placeholder="Deuxi\xE8me pr\xE9nom" class="form-control col-xs-12" name="deuxieme_prenom" type="text" ng-model="$ctrl.contact.prenom2"/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Troisi\xE8me pr\xE9nom :</label> <input placeholder="Troisi\xE8me pr\xE9nom" class="form-control col-xs-12" name="troisieme_prenom" type="text" ng-model="$ctrl.contact.prenom3"/></div></div></div></div><div class="row"><div><div ng-style="{\'visibility\': $ctrl.isCoacquereur===1?\'visible\':\'hidden\'}" class="col-xs-12"> <input ng-change="$ctrl.onCopyAddress()" id="checkbox2{{$id}}" type="checkbox" ng-model="$ctrl.contact.sameAdress"/> <label class="checkbox" for="checkbox2{{$id}}">Adresse du domicile de l\'acqu\xE9reur</label></div></div><div><div class="col-xs-12 mb-05"><div class="row"><div class="col-xs-12 col-md-4 mb-05"> <label class="control-label force-label">Pays :</label><country country-id="$ctrl.contact.pays" country="$ctrl.countrySelected" params="{active: 1}"></country></div><div class="col-xs-12 col-md-4 mb-05"> <label class="control-label force-label">T\xE9l\xE9phone mobile :</label><div class="input-group"> <span class="input-group-addon"><span ng-if="$ctrl.countrySelected.tel">+{{ $ctrl.countrySelected.tel }}</span></span> <input placeholder="T\xE9l\xE9phone mobile" class="form-control" name="tel_mobile" type="text" ng-model="$ctrl.contact.tel_mobile" ng-required="true"/></div> <label style="margin-bottom:0;" ng-if="formValidAcquereur.tel_mobile.$error.parse">Veuillez saisir un num\xE9ro de t\xE9l\xE9phone mobile</label></div><div class="col-xs-12 col-md-4 mb-05"> <label class="control-label force-label">Email :</label> <input placeholder="Email *" class="form-control" name="email" type="email" ng-model="$ctrl.contact.email" ng-required="true" required/></div></div></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Adresse :</label> <input placeholder="Adresse" class="form-control" name="adresse1" type="text" ng-model="$ctrl.contact.adresse1"/></div><div class="col-xs-12 mb-05"> <label class="control-label force-label">Compl\xE9ment d\'adresse :</label> <input placeholder="Compl\xE9ment d\'adresse" class="form-control" name="adresse2" type="text" ng-model="$ctrl.contact.adresse2"/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">CP :</label> <input placeholder="CP" class="form-control" name="cp" type="text" ng-model="$ctrl.contact.cp"/></div><div class="col-xs-12 col-sm-4 mb-05 pl-0"> <label class="control-label force-label">Ville :</label> <input placeholder="Ville" class="form-control" name="ville" type="text" ng-model="$ctrl.contact.ville"/></div><div class="col-xs-12 col-sm-4 mb-05 pl-0"> <label class="control-label force-label">Pays :</label> <input placeholder="Pays" class="form-control" name="pays" type="text" ng-model="$ctrl.contact.adresse_pays"/></div></div><div class="col-xs-12 col-sm-3 mb-05"><div class="input-group w-100"> <label class="control-label force-label">Date de naissance :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.contact.date_naissance" as-date ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" alt-input-formats="altInputFormats" placeholder="Date de naissance" readonly/></div></div><div class="col-xs-12 col-sm-3 mb-05"> <label class="control-label force-label">Ville de naissance :</label> <input placeholder="Ville de naissance" class="form-control" type="text" ng-model="$ctrl.contact.ville_naissance"/></div><div class="col-xs-12 col-sm-3 mb-05"> <label class="control-label force-label">Code du d\xE9partement de naissance :</label> <input placeholder="D\xE9partement de naissance (code)" class="form-control" type="text" ng-model="$ctrl.contact.departement_naissance"/></div><div class="col-xs-12 col-sm-3 mb-05 pl-0"> <label class="control-label force-label">Pays de naissance :</label> <input placeholder="Pays de naissance" class="form-control" type="text" ng-model="$ctrl.contact.pays_naissance"/></div><div class="col-xs-12 col-sm-4 mb-05"> <label class="control-label force-label">Emploi / activit\xE9 :</label> <input placeholder="emploi/activite" class="form-control" type="text" ng-model="$ctrl.contact.emploi_activite"/></div><div class="col-xs-12 col-sm-4 mb-05"><div class="form-group m-0"> <label class="control-label force-label">Situation familiale :</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" name="regime" ng-model="$ctrl.contact.situation_familiale"><option value="">Situation</option><option value="mari\xE9(e)">Mari\xE9(e)</option><option value="pacs\xE9(e)">Pacs\xE9(e)</option><option value="divorc\xE9(e)">Divorc\xE9(e)</option><option value="s\xE9par\xE9(e)">S\xE9par\xE9(e)</option><option value="union libre">Union libre</option><option value="c\xE9libataire">C\xE9libataire</option><option value="veuf(ve)">Veuf(ve)</option><option value="Associ\xE9s">Associ\xE9s</option></select></div></div></div><div class="col-xs-12 col-sm-4 mb-05" ng-show="$ctrl.contact.situation_familiale===\'pacs\xE9(e)\'"><div class="row"><div class="col-xs-12 col-sm-6 pl-0"><div class="form-group m-1"><div class="input-group w-100"> <label class="control-label force-label">Date du pacse :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.contact.date_pacs" as-date ng-click="openDatePacs = true" is-open="openDatePacs" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" placeholder="Date du pacse" alt-input-formats="altInputFormats" readonly/></div></div></div><div class="col-xs-12 col-sm-6 pl-0"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Lieu du pacse :</label> <input placeholder="Lieu du pacse" class="form-control" type="text" ng-model="$ctrl.contact.pacs_lieu"/></div></div></div></div></div><div class="col-xs-12 col-sm-4 mb-05 pl-0" ng-show="$ctrl.contact.situation_familiale===\'divorc\xE9(e)\'"><div class="row"><div class="col-xs-12 col-sm-6 pl-0"><div class="form-group m-1"><div class="input-group w-100"> <label class="control-label force-label">Date du divorce :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.contact.date_divorce" as-date ng-click="openDateDivorce = true" is-open="openDateDivorce" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" placeholder="Date du divorce" alt-input-formats="altInputFormats" readonly/></div></div></div><div class="col-xs-12 col-sm-6 pl-0"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Lieu du divorce :</label> <input placeholder="Lieu du divorce" class="form-control" type="text" ng-model="$ctrl.contact.divorce_lieu"/></div></div></div></div></div><div class="col-xs-12 col-sm-4 mb-05" ng-show="$ctrl.contact.situation_familiale===\'mari\xE9(e)\'"><div class="form-group m-0"> <label class="control-label force-label">R\xE9gime :</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" name="regime" ng-model="$ctrl.contact.regime"><option>R\xE9gime de la communaut\xE9 r\xE9duite aux acquets</option><option>R\xE9gime de la s\xE9paration</option></select></div></div></div><ng-container ng-show="$ctrl.contact.situation_familiale===\'mari\xE9(e)\'"><div class="col-xs-12 col-sm-3"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Date du mariage :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.contact.date_mariage" as-date ng-click="openDatePickerOther = true" is-open="openDatePickerOther" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" placeholder="Date du mariage" alt-input-formats="altInputFormats" readonly/></div></div></div><div class="col-xs-12 col-sm-3"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Lieu du mariage :</label> <input placeholder="Lieu de mariage" class="form-control" type="text" ng-model="$ctrl.contact.lieu_mariage"/></div></div></div><div class="col-xs-12 col-sm-3"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Contrat conclu le :</label> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.contact.contrat_mariage" as-date ng-click="openDateContratMariage = true" is-open="openDateContratMariage" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" placeholder="Contrat conclu le" alt-input-formats="altInputFormats" readonly/></div></div></div><div class="col-xs-12 col-sm-3"><div class="form-group m-0"><div class="input-group w-100"> <label class="control-label force-label">Nom du notaire ayant re\xE7u le contrat :</label> <input placeholder="Nom du notaire ayant re\xE7u le contrat" class="form-control" type="text" ng-model="$ctrl.contact.notaire_mariage"/></div></div></div></ng-container></div><div class="row mt-2"><div class="col-xs-12"><div class="acquiert-pourcent-container bold"> Acquiert <input class="form-control in-text orange" type="number" pattern="+(.d{2})?" min="0" max="100" ng-model="$ctrl.contact.acquiert_pourcent"/> % du bien</div></div></div></form>');
$templateCache.put('src/signature/template/form-pret.html','<form name="{{$ctrl.formName}}" class="" ng-class="{\'form-disabled\': $ctrl.formDisabled}" novalidate><div ng-init="$ctrl.initForm()"><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="nature_pret">Nature :</label><div class="col-xs-12"> <select class="form-control" id="type_pret" name="nature_pret" ng-model="$ctrl.pret.nature" ng-disabled="$ctrl.formDisabled"><option value="">Nature</option><option value="Bancaire">Bancaire</option><option value="0%">0%</option><option value="1%">1%</option><option value="pas">PAS</option><option value="pel">PEL</option><option value="fonctionnaire">Fonctionnaire</option><option value="pls">PLS</option></select></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="type_pret">Type :</label><div class="col-xs-12"> <select class="form-control" id="type_pret" name="type_pret" ng-model="$ctrl.pret.type" ng-required="!$ctrl.formDisabled" ng-disabled="$ctrl.formDisabled"><option value="">Type</option><option value="Pr\xEAt relais">Pr\xEAt relais</option><option value="Pr\xEAt classique">Pr\xEAt classique</option><option value="Pr\xEAt R\xE9visable">Pr\xEAt R\xE9visable</option><option value="Pr\xEAt hypoth\xE9caire">Pr\xEAt hypoth\xE9caire</option><option value="Pr\xEAt Cap\xE9">Pr\xEAt Cap\xE9</option><option value="Pr\xEAt Infine">Pr\xEAt Infine</option></select></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="montant_pret">Montant du pr\xEAt (en \u20ACuros) :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.pret.montant" min="0" step="1" class="form-control" id="montant_pret" placeholder="" ng-required="!$ctrl.formDisabled" ng-disabled="$ctrl.formDisabled" ng-keyup="$ctrl.format(\'pret\',\'montant\')"/></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="duree_pret">Dur\xE9e (en mois) :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.pret.duree" min="0" step="1" class="form-control" id="duree_pret" placeholder="" ng-required="!$ctrl.formDisabled" ng-disabled="$ctrl.formDisabled"/></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="banque_pret">Banque :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.pret.banque" class="form-control" id="banque_pret" placeholder="" ng-required="!$ctrl.formDisabled" ng-disabled="$ctrl.formDisabled"/></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="remboursement_pret">Remboursement mensuel (en \u20ACuros) :</label><div class="col-xs-12"> <input type="text" ng-model="$ctrl.pret.remboursement_mensuel" min="0" step="0.1" class="form-control" id="remboursement_pret" placeholder="" ng-required="!$ctrl.formDisabled" ng-disabled="$ctrl.formDisabled" ng-keyup="$ctrl.format(\'pret\',\'remboursement_mensuel\')"/></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label" for="taux_pret">Taux effectif global :</label><div class="col-xs-12"> <input type="number" ng-model="$ctrl.pret.taux_effectif_global" min="0" step="0.01" class="form-control" id="taux_pret" placeholder="" ng-disabled="$ctrl.formDisabled"/></div></div><div class="form-group row"> <label class="control-label col-xs-12 force-label">Date limite obtention de pr\xEAt :</label><div class="col-xs-12"><div class="input-group"> <input type="text" as-date class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.pret.date_limite_obtention" ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptions" show-button-bar="false" ng-disabled="$ctrl.formDisabled" readonly/><span class="input-group-addon"><span class="glyphicon glyphicon-time" ng-click="openDatePickerEnd"></span></span></div></div></div></div></form>');}]);